export default "__VITE_ASSET__02c80398__"